/**
 * @generated SignedSource<<8314031cb72b2628e29a5a3038f05a2d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type designCard_versionIssueAssociatedDesigns_devOpsDesign$data = {
  readonly associatedIssues: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "JiraIssue";
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"simpleIssueCard_versionIssueAssociatedDesigns">;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly displayName: string;
  readonly id: string;
  readonly lastUpdated: AGG$DateTime;
  readonly provider: {
    readonly logoUrl: AGG$URL;
  };
  readonly url: AGG$URL;
  readonly " $fragmentType": "designCard_versionIssueAssociatedDesigns_devOpsDesign";
};
export type designCard_versionIssueAssociatedDesigns_devOpsDesign$key = {
  readonly " $data"?: designCard_versionIssueAssociatedDesigns_devOpsDesign$data;
  readonly " $fragmentSpreads": FragmentRefs<"designCard_versionIssueAssociatedDesigns_devOpsDesign">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudAri"
    }
  ],
  "kind": "Fragment",
  "name": "designCard_versionIssueAssociatedDesigns_devOpsDesign",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "url"
      },
      "action": "THROW",
      "path": "url"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "displayName"
      },
      "action": "THROW",
      "path": "displayName"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "lastUpdated"
      },
      "action": "THROW",
      "path": "lastUpdated"
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "cloudAri"
          }
        ],
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "logoUrl"
            },
            "action": "THROW",
            "path": "provider.logoUrl"
          }
        ]
      },
      "action": "THROW",
      "path": "provider"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        }
      ],
      "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection",
      "kind": "LinkedField",
      "name": "associatedIssues",
      "plural": false,
      "selections": [
        {
          "concreteType": "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "FragmentSpread",
                      "name": "simpleIssueCard_versionIssueAssociatedDesigns"
                    }
                  ],
                  "type": "JiraIssue"
                },
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "associatedIssues(first:2)"
    }
  ],
  "type": "DevOpsDesign"
};
})();

(node as any).hash = "bb9498fa38fb746e3897ed942c1b67ca";

export default node;
